import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const DASHBOARD_LS_KEY = 'dashboard';

function readStoredDashboard() {
  try {
    const raw = localStorage.getItem(DASHBOARD_LS_KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) {}
  return {};
}

function isMobileViewport() {
  if (typeof window === 'undefined') return false;
  try {
    return window.matchMedia('(max-width: 767px)').matches;
  } catch (e) {
    return false;
  }
}

function readInitialNavbarCollapsed() {
  const stored = readStoredDashboard();
  const isCollapsed = (typeof stored.navbarCollapsed === 'boolean') ? stored.navbarCollapsed : false;
  return isMobileViewport() ? true : isCollapsed;
}

const NavbarCollapsedContext = createContext({
  navbarCollapsed: false,
  setNavbarCollapsed: () => {},
  toggleNavbarCollapsed: () => {},
});

export function NavbarCollapsedProvider({ children }) {
  const [navbarCollapsed, setNavbarCollapsedState] = useState(readInitialNavbarCollapsed);

  const setNavbarCollapsed = useCallback((value) => {
    setNavbarCollapsedState((prev) => {
      const next = typeof value === 'function' ? value(prev) : value;
      try {
        const existing = readStoredDashboard();
        localStorage.setItem(
          DASHBOARD_LS_KEY,
          JSON.stringify({ ...existing, navbarCollapsed: next })
        );
      } catch (e) {}
      return next;
    });
  }, []);

  const toggleNavbarCollapsed = useCallback(() => {
    setNavbarCollapsed((collapsed) => !collapsed);
  }, [setNavbarCollapsed]);

  const value = useMemo(() => ({
    navbarCollapsed,
    setNavbarCollapsed,
    toggleNavbarCollapsed,
  }), [navbarCollapsed, setNavbarCollapsed, toggleNavbarCollapsed]);

  return (
    <NavbarCollapsedContext.Provider value={value}>
      {children}
    </NavbarCollapsedContext.Provider>
  );
}

export function useNavbarCollapsed() {
  return useContext(NavbarCollapsedContext);
}
